import { useUnit } from 'effector-react';
import { BarChart3, Bell, ChartCandlestick, Eye, Layers, Settings } from 'lucide-react';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { $openAlerts } from '../../entities/alert';
import { $positions } from '../../entities/position';
import { routes } from '../../shared/routing';
import { NavButton, Wordmark } from '../../shared/ui';

export type Page = 'positions' | 'alerts' | 'stats' | 'charts' | 'watchlist' | 'settings';

export function Sidebar({
  current,
  onNavigate,
}: {
  current: Page | null;
  onNavigate?: () => void;
}) {
  const { t } = useTranslation();
  const [positions, alerts] = useUnit([$positions, $openAlerts]);
  const go = (page: Page) => () => {
    void routes[page].open();
    onNavigate?.();
  };
  const item = (page: Page, icon: ReactNode, count?: number) => (
    <NavButton
      key={page}
      icon={icon}
      label={t(`nav.${page}`)}
      count={count}
      active={current === page}
      onClick={go(page)}
    />
  );
  return (
    <nav aria-label={t('nav.label')} className="flex h-full flex-col bg-bg-1">
      <div className="flex h-9 shrink-0 items-center px-3">
        <Wordmark />
      </div>
      <div className="space-y-0.5 px-1.5">
        {item('positions', <Layers />, positions?.length)}
        {item('alerts', <Bell />, alerts.length)}
        {item('stats', <BarChart3 />)}
        {item('charts', <ChartCandlestick />)}
        {item('watchlist', <Eye />)}
      </div>
      <div className="mx-3 my-2 h-px bg-border-subtle" />
      <div className="space-y-0.5 px-1.5">{item('settings', <Settings />)}</div>
    </nav>
  );
}
